import classNames from 'classnames';
import styles from './Navigation.module.scss';
import { useEffect, useState } from 'react';
import { NavigationList, NavigationListProps } from './NavigationList/NavigationList';
import React from 'react';

export interface NavigationProps extends NavigationListProps {
	className?: string;
	style?: 'primary';
	children?: React.ReactNode;
}

export const UI_Navigation = React.forwardRef<HTMLElement, NavigationProps>(function UI_Navigation(
	{ className, style, children, navigationItems, maxLevels },
	ref,
) {
	const [openItems, setOpenItems] = useState<string[]>([]);

	useEffect(() => {
		setOpenItems([]);
	}, []);

	const toggle = (id: string) => {
		setOpenItems((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]));
	};

	return (
		<nav className={classNames(styles.Navigation, styles[`Navigation___${style}`], className)} ref={ref}>
			<NavigationList
				className={styles.Navigation_list}
				id="primary-navigation"
				navigationItems={navigationItems}
				maxLevels={maxLevels}
				clickHandler={toggle}
				state={openItems}
			/>
			{children}
		</nav>
	);
});
